import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=4ba3237e&scoped=true"
import script from "./reviewList.vue?vue&type=script&lang=js"
export * from "./reviewList.vue?vue&type=script&lang=js"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=4ba3237e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3237e",
  null
  
)

export default component.exports